import React, { useEffect, useRef } from 'react';
import './Hero.css';

const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero" ref={heroRef}>
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <p className="hero-eyebrow"><span></span> Computer Engineering, University of Waterloo</p>
            <h1 className="hero-name">Lucas Chen</h1>
            <p className="hero-tagline">I build automation and test infrastructure for reliable systems.</p>
            <p className="hero-description">
              Experience in embedded software, PKI-based access control, CI/CD, and
              Python tooling.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={() => scrollToSection('projects')}>Explore Projects</button>
              <a className="btn btn-secondary" href="/Lucas_Chen_Resume.pdf" target="_blank" rel="noopener noreferrer">Resume</a>
            </div>
            <div className="hero-metrics">
              <div>
                <strong>10+ hrs/week</strong>
                <span>Manual reporting work saved</span>
              </div>
              <div>
                <strong>50%</strong>
                <span>Manual test time reduced</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="system-panel">
              <div className="panel-header">
                <span className="panel-dots"></span>
                validation status
              </div>
              <div className="system-graph" aria-hidden="true">
                <span className="graph-path path-one"></span>
                <span className="graph-path path-two"></span>
                <span className="graph-node node-one"></span>
                <span className="graph-node node-two"></span>
                <span className="graph-node node-three"></span>
                <span className="graph-node node-four"></span>
              </div>
              <div className="system-rows">
                <div>
                  <span>identity validation</span>
                  <strong>PKI / X.509</strong>
                  <em className="status-ok">verified</em>
                </div>
                <div>
                  <span>interface testing</span>
                  <strong>gRPC / OpenConfig</strong>
                  <em className="status-ok">active</em>
                </div>
                <div>
                  <span>automation</span>
                  <strong>Python / Pytest</strong>
                  <em className="status-ok">ready</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
